import style from "./ProgramInfo.module.scss";
import PointIcon from "../../../public/ico/point_icon.svg";

// const lists = [
// 	{ id: 1, items: ["Content creator", "Digital Artist", "Blogger", "Course Educator"] },
// 	{ id: 2, items: ["Freelancer", "Professional Affiliate Marketer", "Coach or Consultant", "Interior designer"] },
// ];

const lists = [
	{
		id: 1,
		items: [
			{
				name: "Content creator",
				dictName: "page_affiliate_role1",
			},
			{
				name: "Digital Artist",
				dictName: "page_affiliate_role2",
			},
			{
				name: "Blogger",
				dictName: "page_affiliate_role3",
			},
			{
				name: "Course Educator",
				dictName: "page_affiliate_role4",
			},
		],
	},
	{
		id: 2,
		items: [
			{
				name: "Freelancer",
				dictName: "page_affiliate_role5",
			},
			{
				name: "Professional Affiliate Marketer",
				dictName: "page_affiliate_role6",
			},
			{
				name: "Coach or Consultant",
				dictName: "page_affiliate_role7",
			},
			{
				name: "Interior designer",
				dictName: "page_affiliate_role8",
			},
		],
	},
];

function ProgramInfo({ dictionary }) {
	return (
		<section className={style.container}>
			<div className={style.info}>
				<h2 className={style.title} dangerouslySetInnerHTML={{ __html: dictionary["page_affiliate_header2"] || "What is BgRem's affiliate program?" }} />
				<p className={style.text}>
					{dictionary["page_affiliate_descriptor2"] ||
						"Your clients, subscribers and friends will enjoy learning how to use artificial intelligence to grow their business. When you refer them to BgRem with your special link, we will pay you 30% of the purchase price."}
				</p>
			</div>
			<div className={style.points}>
				<p className={style.subtitle}>{dictionary["page_affiliate_sign_up_if"] || "Sign up if you are a:"}</p>
				<div className={style.lists}>
					{lists.map((list) => {
						return (
							<ul key={list.id} className={style.list}>
								{list.items.map((item) => {
									return (
										<li key={item.name} className={style.item}>
											<PointIcon className={style.icon} />
											{dictionary[item.dictName] || item.name}
										</li>
									);
								})}
							</ul>
						);
					})}
				</div>
			</div>
		</section>
	);
}

export default ProgramInfo;
